import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class PaymentService {
  constructor(private http: HttpClient) {}

  private baseUrl = `${environment.API_URL}/payments`;

  pay(props: Object): Observable<any> {
    return this.http.post<any>(this.baseUrl, JSON.stringify(props), httpOptions);
  }

  getPublicKey(): Observable<any> {
    return this.http.get(this.baseUrl);
  }

  createPaymentIntent(props): Observable<any> {
    return this.http.post(`${this.baseUrl}/intent`, props, httpOptions);
  }

  getClientRegisterConfig(): Observable<any> {
    return this.http.get(`${this.baseUrl}/register/config`);
  }

  getRegisterInvoiceResume(props): Observable<any> {
    return this.http.post(`${this.baseUrl}/resume`, props, httpOptions);
  }

  getExpertRegisterInvoiceResume(props): Observable<any> {
    return this.http.post(`${this.baseUrl}/experts/resume`, props, httpOptions);
  }

  createCustomer(props): Observable<any> {
    return this.http.post(`${this.baseUrl}/experts/customers`, props, httpOptions);
  }

  createSubscription(props): Observable<any> {
    return this.http.post(`${this.baseUrl}/experts/subscriptions`, props, httpOptions);
  }

  deleteSubscription(subscriptionId): Observable<any> {
    return this.http.delete(`${this.baseUrl}/subscriptions/${subscriptionId}`, httpOptions);
  }
}
